import { Component, inject } from '@angular/core';
import {
  RDS_DIALOG_DATA,
  RdsDialogModule,
  RdsProgressSpinnerComponent,
} from '@rds/angular-components';

@Component({
  selector: 'inexp-loading-dialog',
  imports: [RdsDialogModule, RdsProgressSpinnerComponent],
  templateUrl: './loading-dialog.component.html',
  styleUrl: './loading-dialog.component.scss',
})
export class LoadingDialogComponent {
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    message: string;
    instruction: string;
  };
}
